import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

import { useObserver } from '../../tools/useObserver';

export const AutoPauseVideo = ({ src, classes }) => {
  const [thumbnail, setThumbnail] = useState(null);
  const [videoRef, videoVisible] = useObserver({}, false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  useEffect(() => {
    if (src.includes('wistia')) {
      fetch(`https://fast.wistia.net/oembed?url=${src}?embedType=async&videoWidth=960`)
        .then((response) => response.json())
        .then((data) => setThumbnail(data.thumbnail_url));
    }
  }, [src]);

  useEffect(() => {
    if (!videoVisible) setVideoPlaying(false);
  }, [videoVisible]);

  return (
    <div className={[...classes, `player-wrapper-${src}`].join(' ')} ref={videoRef}>
      <ReactPlayer
        light={thumbnail ? thumbnail : false}
        className={`react-player-${src}`}
        controls={false}
        url={src}
        onPlay={() => setVideoPlaying(true)}
        playing={videoPlaying}
        width="100%"
        height="100%"
      />
    </div>
  );
};
